import React, { memo, useMemo } from 'react';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { Activity } from 'botframework-directlinejs';
import { TimeStamp } from './TimeStamp';

const useActivityGroupStyles = makeStyles({
  root: {
  },
  activityContainer: {
    '& .message-activity': {
      marginTop: tokens.spacingVerticalM,
    },
  },
  clear: {
    clear: 'both',
  },
});

export interface IActivityGroupProps {
  activities: Activity[];
  renderActivity(activity: Activity): React.ReactNode;
  className?: string;
}

export const ActivityGroup = memo((props: IActivityGroupProps) => {
  const styles = useActivityGroupStyles();
  const {
    activities, renderActivity, className = '',
  } = props;

  const firstActivityTime = useMemo(() => {
    const firstNonWelcomeMessage = activities.find((activity) => activity.type === 'message' && (activity.value as any) !== 'Welcome');
    if (firstNonWelcomeMessage) {
      const parsedTimestamp = +(firstNonWelcomeMessage.timestamp!);
      if (!Number.isNaN(parsedTimestamp) && parsedTimestamp > 0) {
        return new Date(parsedTimestamp);
      }
    }

    return undefined;
  }, [activities]);

  return (
    <div className={mergeClasses(styles.root, 'activity-group', className)}>
      {!!firstActivityTime && <TimeStamp time={firstActivityTime} />}
      <div className={mergeClasses(styles.activityContainer, 'activity-container')}>
        {activities.map((activity) => renderActivity(activity))}
        <div className={styles.clear} aria-hidden="true" />
      </div>
    </div>
  );
});
